import {validateRequired} from "./ValidationFunctions";

export const StartVacationConfig = {
  fields: {
    reason: {
      type: 'text',
      label: 'Reason for time off',
      rules: [validateRequired('Reason')]
    },
    start: {
      type: 'date',
      label: 'Start date (required)',
    },
    expected: {
      type: 'date',
      label: 'Expected return date',
    },
  }
};

export const FinishVacationConfig = {
  fields: {
    reason: {
      type: 'text',
      label: 'Reason for time off',
      rules: [validateRequired('Reason')]
    },
    finish: {
      type: 'date',
      label: 'Finish date',
    },
  }
};
